import { ITrNotificationMessage } from '../../translate';

export const LoadingText = (): ITrNotificationMessage => 'Loading';
